import WindPlot from "../wind";
import WeatherPlot from "../weather";
import { getStationData } from "../util";
import Box from "@mui/material/Box";


export default function Weissensee ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "WEI", "weissensee", "QFF_KLO_GVE");

  return (
    <div>
      <title>Weissensee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Weissensee</h2>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
        </div>
      </div>
    </div>
  );
};
